import { Component, Input, OnInit } from '@angular/core';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() textKey: string;
  @Input() text: string;

  constructor(protected translate: NetzTranslateService) {}

  ngOnInit(): void {}

  get tooltip() {
    if (this.textKey) {
      return this.translate.translateString(this.textKey);
    }

    if (this.text) {
      return this.text;
    }

    return null;
  }
}
